import ClientCarousel from '@/components/home/client-carousel';
import ClientTestimonials from '@/components/home/client-testimonials';
import HomeHero from '@/components/home/home-hero';
import SpecializedSection from '@/components/home/specialized-section';
import Serving from '@/components/home/serving-to-industries';
import Page from './contact-us/page';
import CaseStudies from '@/components/common/case-study-section';
import Blog from '@/components/home/blog';

function Home() {
    return (
        <>
            <main>
                <section className="hero border-b bg-white dark:bg-black home-hero dark:border-b-0">
                    <HomeHero />
                    <ClientCarousel />
                </section>
                <section className="">
                    <SpecializedSection />
                </section>
                <Serving />

                <CaseStudies />
                <ClientTestimonials />

                <Blog />
                <Page />
            </main>
        </>
    );
}
export default Home;
